import React from 'react';

interface ForwardedMessageHeaderProps {
  variant: 'web' | 'mobile';
  isSent?: boolean;
}

const ForwardedIcon: React.FC = () => (
  <svg
    className="forwarded-icon"
    width="12"
    height="12"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10.5 2.5L13.5 5.5L10.5 8.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 5.5H4.5C3.12 5.5 2 6.62 2 8V11.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardedMessageHeader: React.FC<ForwardedMessageHeaderProps> = ({ variant, isSent }) => {
  const prefix = variant === 'web' ? 'cweb' : 'cmob';
  const sentClass = isSent ? 'sent' : 'received';

  return (
    <div className={`${prefix}-forwarded-header ${sentClass}`}>
      <ForwardedIcon />
      <span className={`${prefix}-forwarded-label`}>Encaminhada</span>
    </div>
  );
};

export default ForwardedMessageHeader;
